import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import LearnerProgrammesList from '../../Components/LearnerProgrammesList';
import LearnerModulesList from '../../Components/LearnerModulesList';
import AddCodePopup from '../../Components/Popups/AddCodePopup';
import LearnerContentList from '../../Components/LearnerContentList';
import ThinkToolPopup from '../../Components/Popups/ThinkToolPopup';
import SaveEditPopup from '../../Components/Popups/SaveEditPopup';
import InviteDeclineReasonPopup from '../../Components/Popups/InviteDeclineReasonPopup';
import Notification from '../../Components/Popups/Notification';

import { commonStyles } from '../../styles/styles';
import BreadCrumbArea from '../../Components/BreadCrumbArea';
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBBtn} from "mdbreact";


import UserCard from '../../Components/Cards/UserCard';
import ProgrammesCard from '../../Components/ProgrammesCard';
import ModulesCard from '../../Components/ModulesCard';
import LearnerAssessmentsList from '../../Components/LearnerAssessmentsList';
import LearnerToolsList from '../../Components/LearnerToolsList';

const ToolsView = ({ classes, view }) => (
  <div
    className={classes.mainBackground}
  >
   
 
<MDBContainer fluid>

    <MDBRow>
        <MDBCol className="pl-4" lg="3" md="4"><ProgrammesCard/></MDBCol>
        <MDBCol lg="9" md="8" sm='12'><LearnerToolsList/></MDBCol>
    </MDBRow>
    </MDBContainer>
   
    {view.declineInviteReasonPopup && <InviteDeclineReasonPopup />}
   
  </div>
);

const styles = () => ({
  ...commonStyles,
  userListColumn: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    maxWidth: 267,
    zIndex:1000,
  },
  toolsColumn: {
    display: 'flex',
    flexGrow: 1,
    flexShrink: 0,
    position: 'relative',
    flexDirection: 'column',
    left:-10,
    maxWidth: 230,
    zIndex:900,
  },
  dashboardColumn: {
    display: 'flex',
    flex: 5,
    paddingBottom:5
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    height:'100%',
    paddingBottom:10,
    alignItems: 'stretch',
    overflow: 'auto',
    backgroundColor: '#e8e8e8'
  }
});

export default compose(withStyles(styles))(ToolsView);

ToolsView.propTypes = {
  classes: PropTypes.instanceOf(Object),
  view: PropTypes.instanceOf(Object),
};
